
export const ButtonStyles = (props) => {
  if(props.small) {
    return {
      width: '40px',
      height: '29px',
      color: "#292b2c",
      background: props.hovered || props.active ? "#e1e1e1" : "white",
      borderColor: "#d0d0d0",
      marginRight: '.75em',
      outline: '0'
    }
  }
  return {
    width: '3.63em',
    paddingTop: '.5em',
    paddingBottom: '.2em',
    color: "#292b2c",
    background: props.hovered || props.active ? "#e1e1e1" : "white",
    borderColor: "#d0d0d0",
    marginRight: '.75em',
    outline: '0'
  };
};

export const IconStyles = (small) => {
  return {
    fontSize: '16px',
    verticalAlign: 'middle',
    lineHeight: '12px',
    fontWeight: 'bold',
    marginBottom: '.7em'
  }
};
